import {
	MessageBox
} from 'element-ui';
import {
	Message
} from 'element-ui';
import store from "@/store";
import filedConfig from "@/field.config"
import * as mapping from "@/utils/mapping";
import request from "@/utils/requests";

function fDou(fn, delay = 600) {
	//console.log(fn);
	// 记录上一次的延时器
	let timer = null;
	return function() {
		clearTimeout(timer);
		timer = setTimeout(fn, delay);
	};
}

/**
 * @param {date} time 需要转换的时间
 * @param {String} fmt 需要转换的格式 如 yyyy-MM-dd、yyyy-MM-dd HH:mm:ss
 */
export function formatTime(time, fmt) {
	if (!time) return '';
	else {
		const date = new Date(time);
		const o = {
			'M+': date.getMonth() + 1,
			'd+': date.getDate(),
			'H+': date.getHours(),
			'm+': date.getMinutes(),
			's+': date.getSeconds(),
			'q+': Math.floor((date.getMonth() + 3) / 3),
			S: date.getMilliseconds(),
		};
		if (/(y+)/.test(fmt))
			fmt = fmt.replace(
				RegExp.$1,
				(date.getFullYear() + '').substr(4 - RegExp.$1.length)
			);
		for (const k in o) {
			if (new RegExp('(' + k + ')').test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1,
					RegExp.$1.length === 1 ?
					o[k] :
					('00' + o[k]).substr(('' + o[k]).length)
				);
			}
		}
		return fmt;
	}
}


function throttle(fn, delay = 600) {
	let pre = 0;
	return function() {
		let context = this;
		let args = arguments
		let now = new Date();
		if (now - pre > delay) {
			fn.apply(context, args);
			pre = now;
		}
	}
}

function resetPixel(size) {
	let width = store.getters.clientBody
	if (width < 1200) {
		width = 1200;
	} else if (width > 1440) {
		width = 1440
	}
	// width = 1440
	return (size * width / 1440).toFixed(5)
}

function toast(callback, {
	msg = "确定删除信息?",
	type = '',
	title = "提示",
	confirmText = "确定",
	cancelText = "取消",
	showCancelButton = true,
	dangerouslyUseHTMLString = true
}) {
	return new Promise((resolve, reject) => {
		MessageBox.confirm(msg, title, {
			confirmButtonText: confirmText,
			cancelButtonText: cancelText,
			showCancelButton,
			type,
			dangerouslyUseHTMLString
		}).then(() => {
			callback()
			resolve(true)
		}).catch(() => {
			Message.info({
				type: 'info',
				message: '已取消'
			});
			reject(false)
		});
	})
}

function toast2({
	msg = "确定删除信息?",
	type = '',
	title = "提示",
	confirmText = "确定",
	cancelText = "取消",
	showCancelButton = true,
	showClose = true,
	dangerouslyUseHTMLString = true,
	showCancelMsg = true
}) {
	return new Promise((resolve, reject) => {
		MessageBox.confirm(msg, title, {
			confirmButtonText: confirmText,
			cancelButtonText: cancelText,
			showCancelButton,
			showClose,
			type,
			dangerouslyUseHTMLString,
			distinguishCancelAndClose: true
		}).then(() => {
			resolve(true)
		}).catch(action => {
			if (showCancelMsg) {
				Message.info({
					type: 'info',
					message: '已取消'
				});
			}
			reject(action)
		});
	})
}


function message($msg, $type = "error") {
	Message({
		message: $msg,
		type: $type,
		duration: 5 * 1000
	})
	if ($type === "error") throw new Error($msg)
}

function parseTime(time, cFormat) {
	let date
	const format = cFormat || '{y}/{m}/{d}'
	if (!time) {
		return ""
		// date = new Date()
	} else {
		if (isNaN(time)) time = time.replace("T", " ").trim()
		if (typeof time === 'object') {
			date = time
		} else {
			if ((typeof time === 'string')) {
				if ((/^[0-9]+$/.test(time))) {
					// support "1548221490638"
					time = parseInt(time)
				} else {
					// support safari
					time = time.replace(new RegExp(/-/gm), '/')
				}
			}

			if ((typeof time === 'number') && (time.toString().length === 10)) {
				time = time * 1000
			}
			date = new Date(time)
		}
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	return format.replace(/{([ymdhisa])+}/g, (result, key) => {
		const value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') {
			return ['日', '一', '二', '三', '四', '五', '六'][value]
		}
		return value.toString().padStart(2, '0')
	})
}

function strToTimestamp(dateStr = '') {
	if (dateStr) {
		dateStr = dateStr.substring(0, 19);
		dateStr = dateStr.replace(/-/g, '/');
		return new Date(dateStr).getTime();
	} else {
		return new Date().getTime();
	}

}

function loanStatus(status = 0) {
	return status === 0 ? "未投资" : "已投资"

}


function hasPermission(permission) {
	return ["mock"].indexOf(process.env.VUE_APP_MODE) > -1 || !(store.getters.permissionButtons.indexOf(permission) ===
		-1 && store.getters.permissionMenus.indexOf(permission) === -1);

}

function splitArr(arr, num = 1) {
	let result = []
	for (let i = 0; i < arr.length; i += num) {
		result.push(arr.slice(i, i + num))
	}
	return result
}

function fillArr(arr, obj, num = 1) {
	for (let i = 0; i < num; i++) {
		arr.push(obj)
	}
}

function filterFiled(arr, location) {

	return arr

}


function formatAmt(val) {
	if (empty(val)) {
		if (val != 0) return ""
	}
	return "￥" + (+val).toLocaleString()
}

function formatAmt3(val) {
	if (empty(val)) {
		if (val != 0) return ""
	}
	return "￥" + (+val).toFixed(2).toLocaleString()

}

function formatAmt2(val) {
	if (empty(val)) {
		if (val != 0) return ""
	}
	return val.toLocaleString()
}

function formatSign(val, emptyStr = "-") {
	if (empty(val)) {
		if (val != 0) return emptyStr
	}
	return val + "%"
}

function formatSign2(val, emptyStr = "-") {
	if (empty(val)) {
		if (val != 0) return emptyStr
	}
	return (val * 100).toFixed(2) + "%"
}

function sortByField(arr = [], field, option = {
	type: "number",
	// sort: "ASC",
}) {
	let newArr = [...arr]
	newArr.sort((x, y) => {
		if (option["type"] === "number") {
			return x[field] - y[field]
		} else if (option["type"] === "zh-cn") {
			return x[field].localeCompare(y[field])
		}
	})
	return newArr
}

function formatPeriod(val) {
	return val ? "第" + val + "期" : "整笔"
}

function getHost() {
	return location.protocol + "//" + location.host
}

function getFileContentType(fileName) {

	if (fileName) {
		let ext = fileName.substring(fileName.lastIndexOf('.') + 1)
		let extMap = {
			"pdf": "application/pdf",
			"docx": "application/msword",
		}
		return extMap[ext] ? extMap[ext] : "image/png"
	}
	return ""

}

function blob2String(res) {
	return new Promise((resolve, reject) => {
		let reader = new FileReader()
		reader.readAsText(res, "utf-8")
		reader.onload = function(e) {
			resolve(JSON.parse(reader.result))
		}
	})
}

function hex2rgb(hex) {
	let sColor = hex.toLowerCase();
	//十六进制颜色值的正则表达式
	let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
	// 如果是16进制颜色
	if (sColor && reg.test(sColor)) {
		if (sColor.length === 4) {
			let sColorNew = "#";
			for (let i = 1; i < 4; i += 1) {
				sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
			}
			sColor = sColorNew;
		}
		//处理六位的颜色值
		let sColorChange = [];
		for (let i = 1; i < 7; i += 2) {
			sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
		}
		return sColorChange.join(",")
	}
	return sColor;
}

function goAnchor(val) {
	document.getElementById(val).scrollIntoView()
}

function countArr(arr, field) {
	let hash = {};
	arr.forEach((item) => {
		if (!hash[item[field]]) {
			hash[item[field]] = 1;
		} else {
			hash[item[field]]++;
		}
	});
	return hash;
}

function getExt(fileName) {
	return fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()
}

function empty(v) {
	return !v || (Array.prototype.isPrototypeOf(v) && v.length === 0) || (Object.prototype.isPrototypeOf(v) && Object
		.keys(v).length === 0)
}

function verifyField(form, field) {
	return new Promise((resolve, reject) => {
		form.validateField(field, (valid) => {
			if (valid) {
				reject(valid)
			} else {
				resolve(valid) // 通过
			}
		});
	})
}

function getQueryVariable(url, variable) {
	let urlArr = url.split("?")
	let query = empty(urlArr[1]) ? "" : urlArr[1]
	let vars = query.split("&");
	for (let i = 0; i < vars.length; i++) {
		let pair = vars[i].split("=");
		if (pair[0] == variable) {
			return pair[1];
		}
	}
	return false
}

function getNDaysAgoTimestamp(n, timestamp = "") {
	// 获取当前时间
	let currentDate = new Date();
	if (timestamp) {
		currentDate = new Date(timestamp);
	}

	// 计算 n 天前的日期
	let nDaysAgo = new Date(currentDate);
	nDaysAgo.setDate(currentDate.getDate() - n);

	// 设置时间为 0 点
	nDaysAgo.setHours(0, 0, 0, 0);

	// 获取时间戳
	return nDaysAgo.getTime();
}


function getNMonthsAgoTimestamp(n, timestamp = "") {
	// 获取当前时间
	let currentDate = new Date();
	if (timestamp) {
		currentDate = new Date(timestamp);
	}

	// 计算 n 天前的日期
	let nDaysAgo = new Date(currentDate);
	nDaysAgo.setMonth(currentDate.getMonth() - n);

	// 设置时间为 0 点
	nDaysAgo.setHours(0, 0, 0, 0);

	// 获取时间戳
	return nDaysAgo.getTime();
}

// length 小数位数
function allowNumber(v, option = {
	length: 2,
	max: 10000000,
	min: -10000000,
	allowMinus: false,
}) {
	if (v.indexOf(',') > -1) {
		v = v.replace(/,/g, "")
	}
	let length = option.length !== undefined ? option.length : 2
	let max = option.max !== undefined ? option.max : 100000000
	let min = option.min !== undefined ? option.min : -100000000
	let allowMinus = !!option.allowMinus;
	//"([0-9-]\\d*\\.?\\d{0,"+length+"})?.*$"
	//"^\\D*(\\d*(?:\\.\\d{0,"+length+"})?).*$"
	let pre = "0-9"
	if (allowMinus) pre = "0-9-"
	let pattern
	if (length > 0) {
		pattern = new RegExp("([" + pre + "]\\d*\\.?\\d{0," + length + "})?.*$", 'g')
	} else {
		pattern = new RegExp("([" + pre + "]\\d*)?.*$", 'g')
	}

	v = v.replace(pattern, '$1')
	if (v > max) v = max
	if (v !== "" && v < min) v = min
	return v
}

function allowNumber2(v, option = {
	length: 2,
	max: 10000000,
	min: -10000000,
	allowMinus: false,
}) {
	if (v.indexOf(',') > -1) {
		v = v.replace(/,/g, "")
	}
	let length = option.length !== undefined ? option.length : 2
	let max = option.max !== undefined ? option.max : 100000000
	let min = option.min !== undefined ? option.min : -100000000
	let allowMinus = !!option.allowMinus;
	//"([0-9-]\\d*\\.?\\d{0,"+length+"})?.*$"
	//"^\\D*(\\d*(?:\\.\\d{0,"+length+"})?).*$"
	let pre = "0-9"
	if (allowMinus) pre = "0-9-"
	let pattern
	if (length > 0) {
		pattern = new RegExp("([" + pre + "]\\d*\\.?\\d{0," + length + "})?.*$", 'g')
	} else {
		pattern = new RegExp("([" + pre + "]\\d*)?.*$", 'g')
	}

	v = v.replace(pattern, '$1')
	if (v !== "" && v < min) v = min
	return v
}

function cartesianProduct(arr) {
	// 过滤掉非数组元素和空数组
	const filteredArr = arr.filter(item => !empty(item)).map(item => {
		if (!Array.isArray(item)) {
			item = [item]
		}
		return item
	});
	// 递归计算笛卡尔积
	const getProduct = (a, b) => a.flatMap(d => b.map(e => [d, e].flat()));
	// 计算笛卡尔积，特殊处理只包含单个数组元素的情况
	return filteredArr.reduce((acc, val) => {
		if (acc.length === 0) {
			// 如果累加器是空的，说明是第一次执行，直接返回当前数组的每个元素作为一个单独的数组
			return val.map(item => [item]);
		}
		return getProduct(acc, val);
	}, []);
}

export async function original(url, row, key) {
	if (row[key].indexOf("*") > -1) {
		let res = await request.request({
			url,
			method: "get",
		})
		row[key] = res.data
	}
}


export default {
	fDou,
	throttle,
	resetPixel,
	toast,
	parseTime,
	strToTimestamp,
	hasPermission,
	splitArr,
	filterFiled,
	formatAmt,
	sortByField,
	getHost,
	getFileContentType,
	blob2String,
	hex2rgb,
	loanStatus,
	formatPeriod,
	fillArr,
	goAnchor,
	countArr,
	message,
	toast2,
	...mapping,
	getExt,
	empty,
	formatSign,
	formatSign2,
	verifyField,
	getQueryVariable,
	getNDaysAgoTimestamp,
	allowNumber,
	getNMonthsAgoTimestamp,
	cartesianProduct,
	allowNumber2,
	original,
	formatAmt2,
	formatAmt3

}